import { AlertTrigger, OrderRouteItem, ROUTE_ITEM_LABELS, RouteItem } from '@aloft/toolkit-shared';

type BaseSubNavItem<T extends RouteItem = RouteItem> = {
  label: (typeof ROUTE_ITEM_LABELS)[T];
  route: T;
  parentRoute: OrderRouteItem;
  testID?: string;
  alertTrigger?: AlertTrigger;
};

type BaseSubNavItemWithChildren = BaseSubNavItem & { items: BaseSubNavItem[] };
export type SubNavItemType = BaseSubNavItem | BaseSubNavItemWithChildren;

type BaseNavItem<T extends RouteItem = RouteItem> = {
  label: (typeof ROUTE_ITEM_LABELS)[T];
  route: T;
};

type NavItemWithSubnav = BaseNavItem & { subnav: SubNavItemType[] };
export type NavItemType = NavItemWithSubnav | BaseNavItem;

export const hasSubnav = (b?: NavItemType): b is NavItemWithSubnav =>
  (b as NavItemWithSubnav)?.subnav !== undefined;

export const navItemHasChildren = (b?: SubNavItemType): b is BaseSubNavItemWithChildren =>
  (b as BaseSubNavItemWithChildren)?.items !== undefined;

type NavGroupItem<T> = {
  route: T;
};

export type NavGroup<T> = {
  label: string;
  routes: readonly T[];
};

export type GroupedNavItems<T> = {
  label: string;
  items: T[];
};

export const groupNavItems = <T extends NavGroupItem<K>, K extends string>(
  items: T[],
  groups: readonly NavGroup<K>[],
): GroupedNavItems<T>[] =>
  groups
    .map((group) => ({
      label: group.label,
      items: items.filter((item) => group.routes.includes(item.route)),
    }))
    .filter((group) => group.items.length > 0);
